import { useState } from "react";
import { useChatStore } from "../lib/useChatStore";
import Sidebar from "./Sidebar";
import Thread from "./Thread";
import ChatInput from "./ChatInput";
import Header from "./Header";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { LegalStyleIndicator } from "./LegalStyleIndicator";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface ChatLayoutProps {
  activeConversationId: string | null;
  currentTemplate?: string;
  conversationTitle?: string;
  conversationOwnerId?: string;
}

const ChatLayout = ({ 
  activeConversationId, 
  currentTemplate,
  conversationTitle,
  conversationOwnerId 
}: ChatLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [useWeb, setUseWeb] = useState(false);

  return (
    <div className="flex h-full min-h-0 w-full">
      {/* Desktop Sidebar - só renderiza em telas >= md */}
      <aside className="hidden md:flex md:w-[280px] flex-shrink-0 border-r h-full min-h-0 overflow-hidden">
        <div className="w-full h-full min-h-0 overflow-hidden">
          <Sidebar />
        </div>
      </aside>

      {/* Mobile Sidebar - Sheet drawer */}
      <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
        <SheetContent side="left" className="p-0 w-[280px]">
          {/* Título invisível para acessibilidade */}
          <div className="sr-only">
            <h2>Histórico de Conversas</h2>
            <p>Navegue entre suas conversas anteriores ou crie uma nova</p>
          </div>
          <Sidebar onConversationSelect={() => setSidebarOpen(false)} />
        </SheetContent>
      </Sheet>

      {/* Main com overflow contido */}
      <main className="flex-1 flex flex-col min-h-0 overflow-hidden">
        <Header 
          onMenuClick={() => setSidebarOpen(true)}
          conversationId={activeConversationId}
          conversationTitle={conversationTitle}
          conversationOwnerId={conversationOwnerId}
        />

        {/* Thread com scroll próprio */}
        <div className="flex-1 min-h-0 overflow-hidden" data-tour="messages-area">
          <Thread />
        </div>

        {/* Linha com Tom + Toggle Pesquisar na web */}
        <div className="flex items-center gap-3 px-4 py-2 border-t bg-background/50">
          <div className="flex gap-2" data-tour="style-selector">
            <LegalStyleIndicator 
              conversationId={activeConversationId}
              currentTemplate={currentTemplate}
            />
          </div>
          <div className="flex items-center gap-2 ml-auto">
            <Switch 
              id="web-search-toggle"
              data-tour="web-search-toggle"
              checked={useWeb} 
              onCheckedChange={setUseWeb}
            />
            <Label 
              htmlFor="web-search-toggle" 
              className="text-xs cursor-pointer sm:text-sm"
            >
              Pesquisar na web
            </Label>
          </div>
        </div>

        {/* Input fixo no rodapé */}
        <div className="border-t flex-shrink-0">
          <ChatInput useWeb={useWeb} />
        </div>
      </main>
    </div>
  );
};

export default ChatLayout;
